import React, { useEffect, useState, useRef } from "react";
import { Role } from "../../types/roles";
import { getRoleByName } from "../../services/Administracion/rolesService";

interface RoleModalProps {
    role: Role;
    onClose: () => void;
    onSave: (role: Role) => void;
}

const RoleModal: React.FC<RoleModalProps> = ({ role, onClose, onSave }) => {
    const [roleName, setRoleName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [isFormValid, setIsformValid] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ roleName?: string; roleDescription?: string }>({});
    const roleNameInputRef = useRef<HTMLInputElement>(null);
    const descriptionInputRef = useRef<HTMLTextAreaElement>(null);


    const handleSave = () => {
        onSave({ ...role, role_name: roleName, description, is_active: isActive });
    };

    useEffect(() => {
        if (role.role_id) {
            setRoleName(role.role_name);
            setDescription(role.description || '');
            setIsActive(role.is_active);
            setErrors({});
        }
        if (!role.role_id && roleNameInputRef.current) {
            roleNameInputRef.current.focus();
        } else if (role.role_id && descriptionInputRef.current) {
            descriptionInputRef.current.focus();
        }
    }, [role]);

    useEffect(() => {
        const validarErrores =
            roleName.trim() !== '' &&
            (!errors.roleName || errors.roleName === '') &&
            (!errors.roleDescription || errors.roleDescription === '');
        setIsformValid(validarErrores);
    }, [roleName, isActive, errors]);


    const validateRoleName = async (roleName: string) => {
        console.log('Validando nombre del rol: ', roleName);
        try {
            const existingRole = await getRoleByName(roleName);
            if (existingRole.role_id) {
                return {
                    isValid: false,
                    errorMessage: `El rol ${existingRole.role_name} YA existe`
                }
            }
            return {
                isValid: true,
                errorMessage: ''
            };
        } catch (error: any) {
            if (error.response?.status !== 404) {
                return {
                    isValid: false,
                    errorMessage: 'Error interno al validar el nombre del rol en la BD'
                }
            }
        }
    };

    const validateField = async (field: string, value: string) => {
        let errorMessage = '';
        if (value.trim() === '') {
            errorMessage = 'Este campo es requerido';
        }
        setErrors((prevErrors) => ({ ...prevErrors, [field]: errorMessage }));
        
        if (field === 'roleName' && value.trim() !== '') {
            const validation = await validateRoleName(value);
            if (!validation?.isValid) {
                setErrors((prevErrors) => ({ ...prevErrors, roleName: validation?.errorMessage }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, roleName: '' }));
            }
        }
    }


    return (
        <div className="modal show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content shadow-lg bg-light">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {role.role_id ? 'Editar ' : 'Crear ' } Rol
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Nombre del Rol</label>
                            <input
                                type="text"
                                className={`form-control ${errors.roleName ? 'is-invalid' : ''}`}
                                disabled={!!role.role_id}
                                value={roleName}
                                onBlur={e => validateField('roleName', e.target.value)}
                                onChange={e => setRoleName(e.target.value)}
                                required
                                ref={roleNameInputRef}
                            />
                            {errors.roleName && <div className="invalid-feedback">{errors.roleName}</div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Descripción</label>
                            <textarea
                                className="form-control"
                                rows={3}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                                ref={descriptionInputRef}
                            ></textarea>
                        </div>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={isActive}
                                onChange={e => setIsActive(e.target.checked)}
                            />
                            <label className="form-check-label">Activo</label>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button
                            type="button"
                            disabled={!isFormValid}
                            className="btn btn-primary"
                            onClick={handleSave}
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleModal;